import React from 'react';
import { Menu } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useSidebar } from '@/hooks/useSidebar';

/**
 * Hamburger menu button that opens the sidebar drawer on mobile.
 * Renders nothing on desktop. Uses SidebarContext for state.
 */
export function MobileMenuButton() {
  const { openSidebar, isMobile } = useSidebar();

  if (!isMobile) return null;

  return (
    <Button
      variant="ghost"
      size="sm"
      onClick={openSidebar}
      className="p-2 -ml-2 flex-shrink-0"
      aria-label="Open menu"
    >
      <Menu className="h-5 w-5" />
    </Button>
  );
}
